import axios from 'axios';
import React, { useState } from 'react'
import { toast } from 'react-hot-toast';
import { FaDownload } from 'react-icons/fa6'
function DownloadButton({ item }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (output_url) => {
    // Check if already downloading
    if (isDownloading) {
      toast('A download is already in progress. Please wait.');
      return;
    }

    setIsDownloading(true);

    const fileName = output_url.split('/').pop();
    if (!fileName) {
      toast('Download-Datei nicht gefunden');
      setIsDownloading(false);
      return;
    }

    try {
      const response = await axios.get(output_url, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      setIsDownloading(false);
    } catch (error) {
      toast('Error downloading file: ' + error.message);
      setIsDownloading(false);
    }
  };


  return (
    <>
      {item?.sku_id?.length > 0 ?
        (item?.uploadStatus
          === "processing_failed" || item?.uploadStatus
          === "processed") &&
        <div key={item?.id}><button className="btn-primary flex gap-3" onClick={() => { handleDownload(item?.output_url) }} disabled={isDownloading || item.uploadStatus === 'processing_failed'}><FaDownload /><span className='hidden md:block'>Herunterladen</span></button></div>
        : ""}
    </>

  )
}

export default DownloadButton